import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2197bb',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#697984',
    },
  },
  mixins: {
    denseToolbar: {
      minHeight: 48,
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        html: {
          fontSize: '100%',
          boxSizing: undefined,
        },
        body: {
          backgroundColor: undefined,
        },
        '*, *::before, *::after': {
          boxSizing: undefined,
        },
      },
    },
  },
});

export default theme;
